export default {
  id: {
    type: ['undefined', 'string']
  },
  url: {
    type: ['undefined', 'string']
  },
  created_at: {
    type: ['undefined', 'string']
  },
  updated_at: {
    type: ['undefined', 'string']
  },
  order: {
    type: ['undefined', 'number']
  },
  enabled : {
    type: ['boolean'],
    default: () => true
  },
}
